import AccordionItemPrimary from "../../common/accordion-item/accordion-item-primary/accordion-item-primary";
import { getAssetUrl } from "../../../api/api";
import type { TTenderhubIndustryRecognitionItem } from "../../../types/tenderhub";

type Props = {
  items?: TTenderhubIndustryRecognitionItem[] | null;
};

function getRecognitionLink(
  item: TTenderhubIndustryRecognitionItem
): string | undefined {
  if (item.isFileLink && item.file?.url) {
    return getAssetUrl(item.file.url);
  }
  if (item.url) return item.url;
  return undefined;
}

export default function TenderhubAwardsSection({ items }: Props) {
  const recognitions = Array.isArray(items) ? items : [];
  return (
    <AccordionItemPrimary title="признание в индустрии">
      <ul className="tenderhub-content-list__list">
        {recognitions.map((item) => {
          const link = getRecognitionLink(item);
          return (
            <li key={item.id}>
              {link ? (
                <a
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link"
                >
                  {item.title}
                </a>
              ) : (
                <span className="link">{item.title}</span>
              )}
            </li>
          );
        })}
      </ul>
    </AccordionItemPrimary>
  );
}

